import { render, staticRenderFns } from "./IndividuData.vue?vue&type=template&id=020364ce&"
import script from "./IndividuData.vue?vue&type=script&lang=js&"
export * from "./IndividuData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports